import { makePairLogo, makeMultiLogo } from "@src/constants/pairLogo";
import mathLogo from "@src/assets/tokens/math-logo.png";
import turtleLogo from "@src/assets/tokens/turtle-logo.png";
import eggseggsLogo from "@src/assets/tokens/eggseggs-logo.jpeg";
import latinaLogo from "@src/assets/tokens/latina-logo.png";
import fomoLogo from "@src/assets/tokens/fomo-logo.jpeg";
import mundoLogo from "@src/assets/tokens/mundo-logo.jpeg";
import eggPointLogo from "@src/assets/tokens/eggpoint-logo.jpeg";
import eggLogo from "@src/assets/tokens/EGG.svg";
import endoLogo from "@src/assets/tokens/endo-logo.jpeg";
import marvinLogo from "@src/assets/tokens/marvin-logo.jpeg";
import eggmoonLogo from "@src/assets/tokens/ido-logo.jpeg";
import streetLogo from "@src/assets/tokens/street-logo.svg";
import kolkhozLogo from "@src/assets/tokens/kolkhoz-logo.jpeg";
import forkLogLogo from "@src/assets/tokens/cartel-logo.png";
import cguLogo from "@src/assets/tokens/cgu-logo.png";
import swopLogo from "@src/assets/tokens/SWOP.svg";
import viresLogo from "@src/assets/tokens/VIRES.svg";
import nsbtLogo from "@src/assets/tokens/nsbt-logo.svg";
import ennoLogo from "@src/assets/tokens/enno-logo.svg";
import signLogo from "@src/assets/tokens/sign-logo.svg";
import duxplorerLogo from "@src/assets/tokens/duxplorer-logo.png";
import usdtLogo from "@src/assets/tokens/USDTERC20PPT.svg";
import puzzleLogo from "@src/assets/tokens/PUZZLE.svg";
import wavesLogo from "@src/assets/tokens/waves-logo.svg";
import usdnLogo from "@src/assets/tokens/usdn-logo.svg";
import raceLogo from "@src/assets/tokens/race-logo.svg";
import unknownLogo from "@src/assets/tokens/unknown-logo.svg";
import btcLogo from "@src/assets/tokens/bitcoin.svg";
import ltcLogo from "@src/assets/tokens/ltc.svg";
import ethLogo from "@src/assets/tokens/ethereum.svg";
import usdcLogo from "@src/assets/tokens/usdc.svg";
import eurn from "@src/assets/tokens/eurn.svg";
import wxLogo from "@src/assets/tokens/WX.svg";
import westLogo from "@src/assets/tokens/WEST.svg";
import wctLogo from "@src/assets/tokens/WCT.svg";
import munaLogo from "@src/assets/tokens/MUNA.svg";
import bnbLogo from "@src/assets/tokens/BNB.svg";
import shegLogo from "@src/assets/tokens/SHEG.png";
import yfiLogo from "@src/assets/tokens/YFI.svg";
import ftmLogo from "@src/assets/tokens/FTM.svg";
import linkLogo from "@src/assets/tokens/LINK.svg";
import uniLogo from "@src/assets/tokens/UNI.svg";
import daiLogo from "@src/assets/tokens/DAI.svg";
import tnLogo from "@src/assets/tokens/TN.svg";
import maticLogo from "@src/assets/tokens/MATIC.svg";
import crvLogo from "@src/assets/tokens/CRV.png";
import snsbtLogo from "@src/assets/tokens/SNSBT.png";
import vladLogo from "@src/assets/tokens/VLAD.png";
import usdtViresLogo from "@src/assets/tokens/USDT_VIRES.svg";
import usdcViresLogo from "@src/assets/tokens/USDC_VIRES.svg";
import usdnViresVested from "@src/assets/tokens/usdn-vires-vested.png";
import snsbtTciLogo from "@src/assets/tokens/sNSBT_TCI.svg";
import tsnLogo from "@src/assets/tokens/TSN.svg";
import busdLogo from "@src/assets/tokens/BUSD.svg";
import wartLogo from "@src/assets/tokens/WART.svg";
import ngntLogo from "@src/assets/tokens/NGNT.svg";
import powerLogo from "@src/assets/tokens/POWER.svg";
import tndLogo from "@src/assets/tokens/TND.svg";
import wxbLogo from "@src/assets/tokens/WXB.png";
import plutoLogo from "@src/assets/tokens/pluto.svg";
import WXUSDNWXLP from "@src/assets/tokens/WXUSDNWXLP.svg";
import wxWXUSDN_TCI from "@src/assets/tokens/wxWXUSDN_TCI.svg";
import usdtusdn from "@src/assets/tokens/usdtusdn.svg";
import wxUSDTUSDN_TCI from "@src/assets/tokens/wxUSDTUSDN_TCI.svg";
import USDCUSDNLP from "@src/assets/tokens/usdcusdn.svg";
import wxUSDCUSDN_TCI from "@src/assets/tokens/wxUSDCUSDN_TCI.svg";
import USDCUSDTLP from "@src/assets/tokens/usdcusdt.svg";
import wxUSDCUSDT_TCI from "@src/assets/tokens/wxUSDCUSDT_TCI.svg";
import PUZZLEUSDNLP from "@src/assets/tokens/puzzleusdn.svg";
import wxPUZZLEUSDN_TCI from "@src/assets/tokens/wxPUZZLEUSDN_TCI.svg";
import WW from "@src/assets/tokens/ww.jpeg";
import MINI from "@src/assets/tokens/mini.jpeg";
import SURF from "@src/assets/tokens/surf.svg";
import SWAVES from "@src/assets/tokens/swaves.svg";
import USDTWXG from "@src/assets/tokens/USDTWXG.svg";
import USDCWXG from "@src/assets/tokens/USDCWXG.svg";
import WBTCWXG from "@src/assets/tokens/WBTCWXG.svg";
import BURNXTN from "@src/assets/tokens/BURNXTN.svg";
import NEXT_WEEK_PEPE from "@src/assets/tokens/NEXTWEEKPEPE.png";
import eastLogo from "@src/assets/tokens/EAST.svg";
import wbtcErc20Logo from "@src/assets/tokens/WBTCERC20.svg";
import usdcBscLogo from "@src/assets/tokens/USDCBEP20.svg";
import btcbLogo from "@src/assets/tokens/BTCB.svg";
import orientLogo from "@src/assets/tokens/ORIENT.svg";
import anoteLogo from "@src/assets/tokens/ANOTE.svg";
import wavesdlpLogo from "@src/assets/tokens/WAVSEDLP.svg";
import peteLogo from "@src/assets/tokens/PETE.svg";
import l2mpLogo from "@src/assets/tokens/L2MP.svg";
import wlgoldLogo from "@src/assets/tokens/wlgold_.svg";
import wlacresLogo from "@src/assets/tokens/ACRES.svg";
import usdtBscLogo from "@src/assets/tokens/USDTBEP20.svg";
import usdtpptLogo from "@src/assets/tokens/USDTPPT.svg";
import usdtpolyLogo from "@src/assets/tokens/USDTPOLYPPT.svg";
import oldgoldLogo from "@src/assets/tokens/OLDGOLD.jpg";
import whirlpoolLogo from "@src/assets/tokens/WHIRLPOOL.jpeg";
import plwavesLogo from "@src/assets/tokens/PLWAVES.svg";
import plethLogo from "@src/assets/tokens/PL-ETH.svg";
import plusdtLogo from "@src/assets/tokens/PL-USDT.svg";
import plpuzzleLogo from "@src/assets/tokens/PL-PUZZLE.svg";
import romeLogo from "@src/assets/tokens/ROME.svg";
import pWavesLogo from "@src/assets/tokens/pWaves.png";
import pool5Logo from "@src/assets/tokens/5POOL.jpeg";
import pzWebLogo from "@src/assets/tokens/WEBPOOL.svg";
import pzUnitsLogo from "@src/assets/tokens/UNITS.jpeg";
import pzBurnXtnLogo from "@src/assets/tokens/PZ-BURN-XTN.jpg";
import pzBbbLogo from "@src/assets/tokens/PZ-BBB.jpg";
import pzBurnXtnXPptLogo from "@src/assets/tokens/PZ-BURN-XTN-x-PPT.jpg";
import windLogo from "@src/assets/tokens/WIND.png";
import sbtLogo from "@src/assets/tokens/SBT.svg";
import fudtLogo from "@src/assets/tokens/FUDT.svg";
import wbriacashLogo from "@src/assets/tokens/WBriacash.svg";
import wbriacash2Logo from "@src/assets/tokens/WBRIACASH2.svg";
import sashaxLogo from "@src/assets/tokens/Sasha-X.svg";
import gxwxLogo from "@src/assets/tokens/gxWX.svg";
import wocLogo from "@src/assets/tokens/WOC.svg";
import pzBarsikLogo from "@src/assets/tokens/PZ_BARSIK.svg";
import baiLogo from "@src/assets/tokens/BAI.svg";
import unit0Logo from "@src/assets/tokens/UNIT0.jpg";
import romekeeperLogo from "@src/assets/tokens/ROMEKEEPER.svg";
import bomeLogo from "@src/assets/tokens/BOME.png";
import apeLogo from "@src/assets/tokens/APE.png";
import bonkLogo from "@src/assets/tokens/BONK.png";
import chillguyLogo from "@src/assets/tokens/CHILLGUY.png";
import dogeLogo from "@src/assets/tokens/DOGE.png";
import goatLogo from "@src/assets/tokens/GOAT.png";
import neiroLogo from "@src/assets/tokens/NEIRO.png";
import pepeLogo from "@src/assets/tokens/PEPE.png";
import popcatLogo from "@src/assets/tokens/POPCAT.png";
import shibLogo from "@src/assets/tokens/SHIB.png";
import spxLogo from "@src/assets/tokens/SPX6900.png";
import wifLogo from "@src/assets/tokens/WIF.png";

const tokenLogos: Record<string, string> = {
  DUXPLORER: duxplorerLogo,
  MATH: mathLogo,
  TURTLE: turtleLogo,
  EGGSEGGS: eggseggsLogo,
  PESOLATINO: latinaLogo,
  FOMO: fomoLogo,
  MUNDO: mundoLogo,
  EGGPOINT: eggPointLogo,
  EGG: eggLogo,
  NEWEGG: eggLogo,
  OLDEGG:
    "https://raw.githubusercontent.com/puzzlenetwork/static/6b602561e02c0eb62bcdbb18ea4fefe3751d7a3b/EGG.8babd6c1fe27f3854782a2dbf47f91d1%201.svg",
  XTN: usdnLogo,
  ENDO: endoLogo,
  MARVIN: marvinLogo,
  EGGMOON: eggmoonLogo,
  STREET: streetLogo,
  KOLKHOZ: kolkhozLogo,
  FORKLOG: forkLogLogo,
  CGU: cguLogo,
  WAVES: wavesLogo,
  SWOP: swopLogo,
  VIRES: viresLogo,
  NSBT: nsbtLogo,
  ENNO: ennoLogo,
  SIGN: signLogo,
  PUZZLE: puzzleLogo,
  USDT: usdtLogo,
  RACE: raceLogo,
  BTC: btcLogo,
  "ETH-PPT": ethLogo,
  ETHWXG: ethLogo,
  LTC: ltcLogo,
  USDC: usdcLogo,
  EURN: eurn,
  WX: wxLogo,
  WEST: westLogo,
  WCT: wctLogo,
  MUNA: munaLogo,
  BNB_WXG: bnbLogo,
  SHEG: shegLogo,
  YFI: yfiLogo,
  MATIC: maticLogo,
  DAI: daiLogo,
  FTM: ftmLogo,
  CRV: crvLogo,
  TN: tnLogo,
  // "SHIB-WXG": shibLogo,
  UNI: uniLogo,
  LINK: linkLogo,
  SNSBT: snsbtLogo,
  VLAD: vladLogo,
  TSN: tsnLogo,
  BUSD: busdLogo,
  WART: wartLogo,
  PWR: powerLogo,
  NGNT: ngntLogo,
  WXB: wxbLogo,
  PLUTO: plutoLogo,
  L2MP: l2mpLogo,
  SNSBTTCI: snsbtTciLogo,
  VIRES_USDT_LP: usdtViresLogo,
  VIRES_USDC_LP: usdcViresLogo,
  WLGOLD: wlgoldLogo,
  ACRES: wlacresLogo,
  WX_USDNWXLP: WXUSDNWXLP,
  wxWXUSDN_TCI: wxWXUSDN_TCI,
  USDTUSDNWXLP: usdtusdn,
  wxUSDTUSDN_TCI: wxUSDTUSDN_TCI,
  USDCUSDNLP: USDCUSDNLP,
  wxUSDCUSDN_TCI: wxUSDCUSDN_TCI,
  USDCUSDTLP: USDCUSDTLP,
  wxUSDCUSDT_TCI: wxUSDCUSDT_TCI,
  PUZZLEUSDNLP: PUZZLEUSDNLP,
  wxPUZZLEUSDN_TCI: wxPUZZLEUSDN_TCI,
  USDT_WXG: USDTWXG,
  USDC_WXG: USDCWXG,
  BTC_WXG: WBTCWXG,
  ETH_WXG: ethLogo,
  BURN_XTN: BURNXTN,
  WW: WW,
  MINI: MINI,
  SURF: SURF,
  UNKNOWN: unknownLogo,
  VVUSDNLP: usdnViresVested,
  SWAVES: SWAVES,
  TND: tndLogo,
  NEXT_WEEK_PEPE: NEXT_WEEK_PEPE,
  EAST: eastLogo,
  WBTC: wbtcErc20Logo,
  USDT_BSC: usdtBscLogo,
  USDC_BSC: usdcBscLogo,
  BTCB: btcbLogo,
  ORIENT: orientLogo,
  ANOTE: anoteLogo,
  WAVESDLP: wavesdlpLogo,
  PETE: peteLogo,
  BAI: baiLogo,
  PZ_Old_Gold: oldgoldLogo,
  PZ_Mega_Pete: "https://images.wavesducks.com/api/images/DUCK-GGGGAAAA-GG.svg",
  USDT_POLY: usdtpolyLogo,
  USDT_PPT: usdtpptLogo,
  WHIRLPOOL: whirlpoolLogo,
  PL_WAVES: plwavesLogo,
  PL_USDT: plusdtLogo,
  PL_ETH: plethLogo,
  PL_PUZZLE: plpuzzleLogo,
  ROME: romeLogo,
  UNIT0: unit0Logo,
  PZ_5pool: pool5Logo,
  PZ_WEB: pzWebLogo,
  PZ_WEBU: "https://puzzleswop.s3.amazonaws.com/f63b754d-8dd8-40c4-83aa-3dd1429a4e18",
  PZ_REWIND: "https://puzzleswop.s3.amazonaws.com/fcf39537-9ead-4e17-bfd9-1330eb3f05ce",
  PZ_UNITS: pzUnitsLogo,
  PZ_BURN_XTN: pzBurnXtnLogo,
  PZ_BBB: pzBbbLogo,
  PZ_BURN_XTN_x_PPT: pzBurnXtnXPptLogo,
  SBT: sbtLogo,
  WIND: windLogo,
  FUDT: fudtLogo,
  WBriacash: wbriacashLogo,
  "WBriacash-LP": wbriacashLogo,
  "WBriacash-Index-LP": wbriacash2Logo,
  "Sasha-X": sashaxLogo,
  gxWX: gxwxLogo,
  "ROME-KEEPER": romekeeperLogo,

  APE: apeLogo,
  BONK: bonkLogo,
  CHILLGUY: chillguyLogo,
  DOGE: dogeLogo,
  GOAT: goatLogo,
  NEIRO: neiroLogo,
  PEPE: pepeLogo,
  POPCAT: popcatLogo,
  SHIB: shibLogo,
  SPX: spxLogo,
  BOME: bomeLogo,
  WIF: wifLogo,
  GORC: "data:image/svg+xml;charset=utf-8;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAzMiAzMiI+PHJlY3QgeD0iMCIgeT0iMCIgcng9IjYiIHJ5PSI2IiB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIGZpbGw9IiMyMTIxMjEiLz48cGF0aCBmaWxsPSIjZmZmIiBkPSJNNyA0aDJ2MWgxdjFoM1Y1aDFWNGg0djFoMXYxaDNWNWgxVjRoMnYxaDF2MTloMXYxaDF2M0g0di0zaDF2LTFoMVY1aDF6Ii8+PGcgZmlsbD0iI2I0NCI+PHBhdGggZD0iTTIzIDRoMnYxaC0yek0xOCA3VjZoLTF2MWgtMlY2aC0xdjFoLTF2MmgxVjdoMXY0aDJWN3pNMTggN2gxdjJoLTF6TTEyIDloLTFWOGgxek0yMCA5aDFWOGgtMXpNMTggMTloLTR2MWg0eiIvPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTIzIDlWNWgtMXYxaC0zVjVoLTFWNGgtNHYxaC0xdjFoLTNWNUg5VjRIN3YxSDZ2MTlINXYxSDR2M2gxdi0zaDF2M2gxVjE3aDF2MTFoMTZWMTdoMXYxMWgxdi0zaDF2M2gxdi0zaC0xdi0xaC0xVjVoLTF2NmgtMVY5em0tMyAwdjFoM1Y5aC0xVjhoLTFWN2gtMlY2aC0xVjVoLTF2MWgtMlY1aC0xdjFoLTF2MWgtMnYxaC0xdjFIOVY1SDd2NmgxVjloMXYxaDNWOWgxdjFoMXYxaDF2Mmgydi0yaDF2LTFoMVY5em0yIDRoLTN2MWgtMXYxaDF2LTFoM3pNNyAxMnYyaDF2MWgxdjJoMXYxaDN2LTFoMXYyaC0xdjFoLTF2MWgtMXY1aDF2MWgxdi01aDF2LTFoNHYxaDF2NWgxdi0xaDF2LTVoLTF2LTFoLTF2LTFoLTF2LTJoMXYxaDN2LTFoMXYtM2gydi0yaC0xdjNoLTJ2MWgtNHYxaC0xdi0yaC0ydjJoLTF2LTFoLTR2LTFIOXYtMUg4di0yem0zIDJ2LTFoM3Yxem0zIDBoMXYxaC0xem0xIDl2MWg0di0xem0wIDRoNHYtMmgtNHptNy03aDF2M2gxdi0zaC0xdi0xaC0xem0tMTAgMHYtMWgtMXYxSDl2M2gxdi0zeiIvPjwvZz48L3N2Zz4=",
  "2PETE":
    "https://i.meme/_next/image?url=https%3A%2F%2Fi.meme%2Fstatic%2F9sgdTJZuFxnGHhBz3fdqwcmKVxQkcMXtNEwvLx7nAbZd_img.jpg&w=640&q=75",
  TITS: "https://i.meme/_next/image?url=https%3A%2F%2Fi.meme%2Fstatic%2F4kedYPas1UEswFS5982TVVYshQeffyKiBQadJkd3inAJ_img.webp&w=640&q=75",
  PERFECT:
    "https://i.meme/_next/image?url=https%3A%2F%2Fi.meme%2Fstatic%2F31LrfAmRPURMhkXAA2kkMpy1j2DULVr3KyKnQ95cEzVW_img.jpg&w=640&q=75",
  "23": "https://i.meme/_next/image?url=https%3A%2F%2Fi.meme%2Fstatic%2F6rE88UixaXYv8kKjjhGKoAm3Vycv9wLz2Esd5gv3sWuw_img.jpg&w=640&q=75",
  SANCHO:
    "https://s3.eu-central-1.amazonaws.com/memecity-prod/meme-city/bf7ee3ff-1805-4ec7-9398-daf06841c535.png?t=1744303065718",

  WX_USDCUSDT_LP: "https://waves.exchange/static/icons/assets/rZMQ6g31Lr7sPAaAoYc4U2PHCVauTuKUSzUbJtUyPZN.svg",
  AXLY: "https://waves.exchange/static/icons/assets/DcAbWMXrfMeooG1BrZ9ipiseFSVm7zxTs1XZKRp6DVeZ.svg",
  USDC_PPT: "https://waves.exchange/static/icons/assets/3ayH3PhWMkhFsySsUVcC8BvFf1QyxGB5BZuTPyVtmP4v.svg",
  USDT_TRC: "https://waves.exchange/static/icons/assets/DaErMEp76HtuvbbSYxDwLovRimaAwtEyQGFeHLQ3UWwh.svg",
  SPICE: "https://wavesducks.com/static/img/token/spice.svg",
  BNB: "https://wavescap.com/wp-content/uploads/asset-logo/66a1br3BrkoaJgP7yEar9hJcSTvJPoH6PYBLqscXcMGo.svg",

  USDTu:
    "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xdAC17F958D2ee523a2206206994597C13D831ec7/logo.png",
  USDCu:
    "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48/logo.png",
  WBTCu:
    "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599/logo.png",
  ETHu: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png",
  SOL: "https://waves-bridge-assets.web.app/logo/SOL/So11111111111111111111111111111111111111112.png",

  TRUMP: "https://s2.coinmarketcap.com/static/img/coins/64x64/35336.png",
  MELANIA: "https://s2.coinmarketcap.com/static/img/coins/64x64/35347.png",

  MEGAMEME: "https://megameme-249514940b30.herokuapp.com/static/media/megameme.49817f851dcdada62613bf2e1f70f56d.svg",

  CRV_WXG: "https://r.wavesexplorer.com/assets/site/img/assets_logo/3KhNcHo4We1G5EWps7b1e5DTdLgWDzctc8S6ynu37KAb.svg",
  SHIB_WXG: "https://r.wavesexplorer.com/assets/site/img/assets_logo/GVxGPBtgVWMW1wHiFnfaCakbJ6sKgZgowJgW5Dqrd7JH.svg",
  DAI_WXG: "https://r.wavesexplorer.com/assets/site/img/assets_logo/8zUYbdB8Q6mDhpcXYv52ji8ycfj4SDX4gJXS7YY3dA4R.svg",
  AURA: "https://wx.network/static/icons/assets/8BrtpekrprCfkqTyZ8vLGoKnvLtUscApws8U9Qusv56M.svg",
  PZL: "https://raw.githubusercontent.com/puzzlenetwork/static/e9d3e0ab82c47fce0696b1afa528d7b7f5d52316/PZL.svg",

  USDC_ERC: usdcLogo,
  PZ_BARSIK: pzBarsikLogo,
  pWAVES: pWavesLogo,
  WOC: wocLogo,

  // Puzzle Range index (paired) tokens — split "cut in half and combine" icon.
  "PR-ROME-pWAVES": makePairLogo(romeLogo, pWavesLogo),
  "PR-SOL-USDTerc20": makePairLogo(
    "https://waves-bridge-assets.web.app/logo/SOL/So11111111111111111111111111111111111111112.png",
    usdtLogo
  ),
  "PR-Cloud-public": makePairLogo(wavesLogo, usdtLogo),

  // 3-token Puzzle Range pool — icon split into three equal pie slices.
  "PR-BRIA-PUZZLE-ROME": makeMultiLogo([wbriacashLogo, puzzleLogo, romeLogo]),
};

export default tokenLogos;
